import React, { useState, useEffect } from "react";
import { Button, Modal, Row, Col, Spinner } from "react-bootstrap";
import AdminExcelHook from "../../hook/admin/AdminExcelHook";
//import ViewSalesProductAdminHook from "../../hook/admin/ViewSalesProductAdminHook";
import AdminOrderItem from "./AdminOrderItem";
import Pagination from "../../Components/Utilities/Pagination";
//import DataTable from "react-data-table-component";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import DataTableExtensions from "react-data-table-component-extensions";
import { useNavigate } from "react-router-dom";
import notify from "../../hook/useNotification";
import { sendEmail } from "../../redux/actions/cartAction";
import { Helmet } from "react-helmet";
import MultiImageInput from "react-multiple-image-input";
import SearchByTypingSelect from "../Utilities/SearchByTypingSelect";
import baseURL from "../../Api/baseURL";
import ProgressBar from "../Utilities/ProgressBar";
import LoadingSpinner from "../Utilities/LoadingSpinner";


const AdminExcel = () => {
  //console.log('excel');
//   let loggedUser=JSON.parse(localStorage.getItem('user'));
//  let role=loggedUser.role;
  //console.log(loggedUser.role);
  const { t } = useTranslation();

  const [
    onSelectCategory,
    category,
    categoriesWithoutBlocked,
    onSelectSubCategory,
    subCategory,
    onSelectBrand,
    brand,
    webSiteData,
    user,
    onChangeVendor,
    vedorId,
    getAllUser,
    images,
    setImages,
    settingsRes,
    isPress,
    onChangeSetExcelFile,
    handleImageChange,
    handleUploadPhotos,
    categoryId,
    selectedsubId,
    brandId,
    handleSubmit,
    loading,
    loadingIMG,
    progress, setProgress,
    excelProgress, setExcelProgress
   
  ] = AdminExcelHook();

  console.log('loadingIMG');
  console.log(loadingIMG);
  
  return (
    <div>
      <Row className="justify-content-start ">
        <div className="admin-content-text pb-4 mt-3">{t("import excel")}</div>
        <Col sm="8">
           <div className="admin-content-text pb-4 mt-3">
            1/{t("download excel")}
          </div>
          <a
            className="btn-save d-inline mt-3 justify-content-end btn-save2"
            href={baseURL.defaults.baseURL+'/public/uploads/productsShelly.xlsx'}
            style={{
              backgroundColor: settingsRes?.data?.primaryColor,
              padding: " 1%",
              "text-decoration": "none",
            }}
          >
          {t("download here")}
          </a>

          

          <div className="admin-content-text pb-4 mt-4" >
          2/{t("fill form")}
          </div>

          <label htmlFor="categoriesProduct" className="d-block mt-1">
            {t("excel information")}
          </label>



          <label htmlFor="categoriesProduct" className="d-block mt-4">
            {t("main classification")}
          </label>

            <SearchByTypingSelect
            value={categoryId}
            onChange={onSelectCategory}
            getOptionLabel={(el) => Cookies.get("i18next") === "ar"? el.nameAr: el.nameEn}
            getOptionValue={(e) => e._id}
            options={ user.role == "vendor" ? categoriesWithoutBlocked :category}
            placeholder={t("main classification")}
             />
        
       
          <label htmlFor="subCategoriesProduct" className="d-block mt-2 ">
            {t("Subcategory")}
          </label>
            <SearchByTypingSelect
              value={selectedsubId}
              onChange={onSelectSubCategory}
              getOptionLabel={(el)=>Cookies.get("i18next") === "ar" ? el.nameAr : el.nameEn}
              getOptionValue={(e) => e._id}
              options={subCategory}
              placeholder={t("Subcategory")}
             />
         
          
          <label htmlFor="brand" className="d-block mt-2 ">
            {t("Brand")}
          </label>
          <SearchByTypingSelect
          value={brandId}
          onChange={onSelectBrand}
          getOptionLabel={(el)=>Cookies.get("i18next") == "ar" ? el.nameAr : el.nameEn}
          getOptionValue={(e) => e._id}
            options={brand.data}
            placeholder={t("Brand")}
           />

       
          

          {webSiteData.MULTI_VENDOR == "true" && user?.role === "admin" && (
            <>
              <label htmlFor="vendor" className="d-block mt-2 ">
                {t("select vendor name")}
              </label>

              <SearchByTypingSelect
              value={vedorId}
              onChange={onChangeVendor}
              getOptionLabel={(el)=>`${el?.firstname} ${el?.lastname}`}
              getOptionValue={(e)=>e._id}
              options={getAllUser}
              placeholder={t("vendor name")}
               />

             
            
            </>
          )}

           <div className="admin-content-text pb-4 mt-4" >
            3/{t("select sub category")}
          </div>
         
          

          <div className="mt-3">
            <label htmlFor="vendor" className="d-block mt-2 ">
              {t("select excel file")}
            </label>
            <input
              onChange={onChangeSetExcelFile}
              type="file"
              accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              style={{ "margin-top": "1%" }}
            />
          </div>

          
        </Col>
      </Row>
      <Row>
        <Col sm="12" className="d-flex justify-content-start mt-4 ">
          <button
            onClick={handleSubmit}
            className="btn-save d-inline mt-3 btn-save2"
            style={{ backgroundColor: settingsRes?.data?.primaryColor }}
            disabled={isPress === true ? true : false}
          >
            <div className="d-flex justify-content-evenly align-items-center ">
              <p
                style={{
                  all: "unset",
                }}
              >
                { loading===false? 'loading...' :t("import")}
              </p>
             
            </div>
          </button>     
        </Col>

         <div>
                <ProgressBar progress={excelProgress} />
        </div>

        <div className="admin-content-text pb-4 mt-4">4/{t("upload photos")}</div>

        <label htmlFor="categoriesProduct" className="d-block mt-1">
            {t("upload photos info")}
        </label>
        <label htmlFor="categoriesProduct" className="d-block">
            {t("upload photos info2")}
        </label>

        <Col sm="8">

       

        <div className="mt-3">

        <input type="file" name="images" id="imgid" className="imgcls" onChange={handleImageChange} accept="image/*" multiple/>
        
            
          </div>

        </Col>

        <Col sm="12" className="d-flex justify-content-start ">
          <button
            onClick={handleUploadPhotos}
            className="btn-save d-inline mt-3 btn-save2 "
            style={{ backgroundColor: settingsRes?.data?.primaryColor }}
            disabled={isPress === true ? true : false}
          >
            <div className="d-flex justify-content-evenly align-items-center">
              <p
                style={{
                  all: "unset",
                }}
              >
                { loadingIMG===true ? t("upload photos now") : <LoadingSpinner /> }
              </p>
              
            </div>
          </button>
        </Col>
        
        <ProgressBar progress={progress} />
          
      </Row>
      <ToastContainer />
    </div>
  );
};

export default AdminExcel;
